import { CustomFormFieldBase } from "./custom-form-field.type";

export class AutocompleteFormControl extends CustomFormFieldBase<string> {
    override controlType = 'autocomplete'; 
}
